import { render, staticRenderFns } from "./conversation-setting.vue?vue&type=template&id=4cd7d09b&"
import script from "./conversation-setting.js?vue&type=script&lang=js&"
export * from "./conversation-setting.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports